<template>
  <SideBar />
 <div class="p-4 sm:ml-64 min-h-screen bg-gray-900 text-white">
  
   <VentaForm />
   <!-- Aquí se renderiza el componente -->
 </div>
</template>


<script>
import VentaForm from "../components/VentaForm.vue";
import SideBar from "../components/NavBar.vue";

export default {
  name: "NewVentaPage",
  components: {
    VentaForm,
    SideBar, // Register the imported component here
  },
};
</script>
